import TodoScreen from './components/TodoScreen'

function App() {
  return (
    <div className="App">
    <TodoScreen />
   
    </div>
  );
}

export default App;
